export default __webpack_public_path__ + "935cb9a.png";